import { OperationVariables, FetchResult, useMutation } from '@apollo/client';
import { useEffect, useState } from 'react';
import PlaidLinkComponent from './plaidLinkComponent';
import { CREATE_LINK_TOKEN, ICreateLinkTokenRes } from './plaidLink.service';
import moment from 'moment';
import Loading from '../loading/loading';

const PlaidLinkWrapper = () => {
  const [createLinkToken] = useMutation(CREATE_LINK_TOKEN);
  const [tokenReady, setTokenReady] = useState(false);

  useEffect(() => {
    const tkn = localStorage.getItem('linkToken');
    const linkToken = tkn !== null ? JSON.parse(tkn) : '';

    if (linkToken === '' || !!linkTokenExpired()) {
      generateToken();
    } else {
      setTokenReady(true);
    }
    // eslint-disable-next-line
  }, []);

  const generateToken = async () => {
    const response: FetchResult<ICreateLinkTokenRes, OperationVariables> =
      await createLinkToken();

    localStorage.setItem(
      'linkToken',
      JSON.stringify(response.data?.createLinkToken.linkToken || '')
    );

    localStorage.setItem(
      'linkTokenTimestamp',
      JSON.stringify(moment(new Date()))
    );

    setTokenReady(true);
  };

  const linkTokenExpired = () => {
    const timestamp = localStorage.getItem('linkTokenTimestamp');
    if (timestamp !== null) {
      const timeStampDateExpiration = moment(
        new Date(JSON.parse(timestamp))
      ).add(29, 'minutes');
      const now = moment(new Date());

      return timeStampDateExpiration.isBefore(now);
    }
  };

  if (!tokenReady) {
    return <Loading isLoading />;
  }

  return (
    <>
      <PlaidLinkComponent />
    </>
  );
};

export default PlaidLinkWrapper;
